"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhantomHDWallet = exports.PhantomHDWalletInfo = void 0;
exports.isPhantom = isPhantom;
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const hdwallet_core_1 = require("@shapeshiftoss/hdwallet-core");
const base64_js_1 = __importDefault(require("base64-js"));
const bitcoinMsg = __importStar(require("bitcoinjs-message"));
const utils_js_1 = require("ethers/lib/utils.js");
const isObject_1 = __importDefault(require("lodash/isObject"));
const btc = __importStar(require("./bitcoin"));
const eth = __importStar(require("./ethereum"));
const solana_1 = require("./solana");
function isPhantom(wallet) {
    return (0, isObject_1.default)(wallet) && wallet._isPhantom;
}
class PhantomHDWalletInfo {
    constructor(evmProvider) {
        this._supportsBTCInfo = true;
        this._supportsETHInfo = true;
        this._supportsSolanaInfo = true;
        this.evmProvider = evmProvider;
    }
    getVendor() {
        return "Phantom";
    }
    hasOnDevicePinEntry() {
        return false;
    }
    hasOnDevicePassphrase() {
        return true;
    }
    hasOnDeviceDisplay() {
        return true;
    }
    hasOnDeviceRecovery() {
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hasNativeShapeShift(srcCoin, dstCoin) {
        return false;
    }
    supportsBip44Accounts() {
        return false;
    }
    supportsOfflineSigning() {
        return false;
    }
    supportsBroadcast() {
        return true;
    }
    describePath(msg) {
        switch (msg.coin.toLowerCase()) {
            case "bitcoin": {
                const unknown = core.unknownUTXOPath(msg.path, msg.coin, msg.scriptType);
                if (!msg.scriptType)
                    return unknown;
                if (!this.btcSupportsCoin(msg.coin))
                    return unknown;
                if (!this.btcSupportsScriptType(msg.coin, msg.scriptType))
                    return unknown;
                return core.describeUTXOPath(msg.path, msg.coin, msg.scriptType);
            }
            case "ethereum":
                return core.describeETHPath(msg.path);
            case "solana":
                return core.solanaDescribePath(msg.path);
            default:
                throw new Error("Unsupported path");
        }
    }
    /** Ethereum */
    ethSupportsNetwork(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            return chainId === 1;
        });
    }
    ethGetChainId() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.evmProvider.request)
                    throw new Error("Provider does not support ethereum.request");
                // chainId as hex string
                const chainId = yield this.evmProvider.request({ method: "eth_chainId" });
                return parseInt(chainId, 16);
            }
            catch (e) {
                console.error(e);
                return null;
            }
        });
    }
    ethSupportsSecureTransfer() {
        return __awaiter(this, void 0, void 0, function* () {
            return false;
        });
    }
    ethSupportsNativeShapeShift() {
        return false;
    }
    ethSupportsEIP1559() {
        return __awaiter(this, void 0, void 0, function* () {
            return true;
        });
    }
    ethGetAccountPaths(msg) {
        return eth.ethGetAccountPaths(msg);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ethNextAccountPath(msg) {
        console.error("Method not implemented");
        return undefined;
    }
    /** Bitcoin */
    btcSupportsCoin(coin) {
        return __awaiter(this, void 0, void 0, function* () {
            return coin.toLowerCase() === "bitcoin";
        });
    }
    btcSupportsScriptType(coin, scriptType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.btcSupportsCoin(coin))
                return false;
            switch (scriptType) {
                case core.BTCInputScriptType.SpendWitness:
                    return true;
                default:
                    return false;
            }
        });
    }
    btcSupportsSecureTransfer() {
        return __awaiter(this, void 0, void 0, function* () {
            return false;
        });
    }
    btcSupportsNativeShapeShift() {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    btcGetAccountPaths(msg) {
        return btc.btcGetAccountPaths(msg);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    btcNextAccountPath(msg) {
        throw new Error("Method not implemented");
    }
    /** Solana */
    solanaGetAccountPaths(msg) {
        return core.solanaGetAccountPaths(msg);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    solanaNextAccountPath(msg) {
        throw new Error("Method not implemented");
    }
}
exports.PhantomHDWalletInfo = PhantomHDWalletInfo;
class PhantomHDWallet extends PhantomHDWalletInfo {
    constructor(evmProvider, bitcoinProvider, solanaProvider) {
        super(evmProvider);
        this._supportsBTC = true;
        this._supportsETH = true;
        this._supportsEthSwitchChain = false;
        this._supportsAvalanche = false;
        this._supportsOptimism = false;
        // Polygon is technically supported but is acting up on the Phantom side of things atm
        // https://github.com/orgs/phantom/discussions/294
        this._supportsPolygon = false;
        this._supportsGnosis = false;
        this._supportsArbitrum = false;
        this._supportsArbitrumNova = false;
        this._supportsBase = true;
        this._supportsBSC = false;
        this._supportsSolana = true;
        this._isPhantom = true;
        this.evmProvider = evmProvider;
        this.bitcoinProvider = bitcoinProvider;
        this.solanaProvider = solanaProvider;
    }
    getDeviceID() {
        return __awaiter(this, void 0, void 0, function* () {
            return "phantom:" + (yield this.solanaGetAddress());
        });
    }
    getFeatures() {
        return __awaiter(this, void 0, void 0, function* () {
            return {};
        });
    }
    getFirmwareVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            return "phantom";
        });
    }
    getModel() {
        return __awaiter(this, void 0, void 0, function* () {
            return "Phantom";
        });
    }
    getLabel() {
        return __awaiter(this, void 0, void 0, function* () {
            return "Phantom";
        });
    }
    isInitialized() {
        return __awaiter(this, void 0, void 0, function* () {
            return true;
        });
    }
    isLocked() {
        return __awaiter(this, void 0, void 0, function* () {
            return !this.evmProvider._metamask.isUnlocked();
        });
    }
    clearSession() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    ping(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return { msg: msg.msg };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendPin(pin) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendPassphrase(passphrase) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendCharacter(charater) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendWord(word) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    cancel() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    wipe() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    reset(msg) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    recover(msg) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loadDevice(msg) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    getPublicKeys(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield Promise.all(msg.map((getPublicKey) => __awaiter(this, void 0, void 0, function* () {
                const { coin, scriptType } = getPublicKey;
                // Only p2wpkh effectively supported for now
                if (coin === "Bitcoin" && scriptType === hdwallet_core_1.BTCInputScriptType.SpendWitness) {
                    // Note this is a pubKey, not an xpub, however phantom does not support utxo derivation,
                    // so this functions as an account (xpub) for all intents and purposes
                    const pubKey = yield this.btcGetAddress({ coin: "Bitcoin" });
                    return { xpub: pubKey };
                }
                return null;
            })));
        });
    }
    /** Ethereum */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ethGetAddress(_msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.ethAddress) {
                return this.ethAddress;
            }
            const address = yield eth.ethGetAddress(this.evmProvider);
            if (address) {
                this.ethAddress = address;
                return address;
            }
            else {
                this.ethAddress = null;
                return null;
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ethSignTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            console.error("Method not implemented");
            return null;
        });
    }
    ethSendTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.ethGetAddress({ addressNList: [] });
            return address ? eth.ethSendTx(msg, this.evmProvider, address) : null;
        });
    }
    ethSignMessage(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.ethGetAddress({ addressNList: [] });
            return address ? eth.ethSignMessage(msg, this.evmProvider, address) : null;
        });
    }
    ethSignTypedData(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.ethGetAddress({ addressNList: [] });
            return address ? eth.ethSignTypedData(msg, this.evmProvider, address) : null;
        });
    }
    ethVerifyMessage(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!msg.signature.startsWith("0x"))
                msg.signature = `0x${msg.signature}`;
            const digest = (0, utils_js_1.keccak256)(core.buildMessage(msg.message));
            return (0, utils_js_1.recoverAddress)(digest, msg.signature) === msg.address;
        });
    }
    /** Bitcoin */
    btcGetAddress(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = yield (() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                switch (msg.coin) {
                    case "Bitcoin": {
                        const accounts = yield this.bitcoinProvider.requestAccounts();
                        const paymentAddress = (_a = accounts.find((account) => account.purpose === "payment")) === null || _a === void 0 ? void 0 : _a.address;
                        return paymentAddress;
                    }
                    default:
                        return null;
                }
            }))();
            if (!value || typeof value !== "string")
                return null;
            return value;
        });
    }
    btcSignTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const { coin } = msg;
            switch (coin) {
                case "Bitcoin":
                    return btc.bitcoinSignTx(this, msg, this.bitcoinProvider);
                default:
                    return null;
            }
        });
    }
    btcSignMessage(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const { coin } = msg;
            switch (coin) {
                case "Bitcoin": {
                    const address = yield this.btcGetAddress({ coin });
                    if (!address)
                        throw new Error(`Could not get ${coin} address`);
                    const message = new TextEncoder().encode(msg.message);
                    const { signature } = yield this.bitcoinProvider.signMessage(address, message);
                    return { signature: core.toHexString(signature), address };
                }
                default:
                    return null;
            }
        });
    }
    btcVerifyMessage(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const signature = base64_js_1.default.fromByteArray(core.fromHexString(msg.signature));
            return bitcoinMsg.verify(msg.message, msg.address, signature);
        });
    }
    /** Solana */
    solanaGetAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            const { publicKey } = yield this.solanaProvider.connect();
            return publicKey.toString();
        });
    }
    solanaSignTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.solanaGetAddress();
            return address ? (0, solana_1.solanaSignTx)(msg, this.solanaProvider, address) : null;
        });
    }
    solanaSendTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.solanaGetAddress();
            return address ? (0, solana_1.solanaSendTx)(msg, this.solanaProvider, address) : null;
        });
    }
}
exports.PhantomHDWallet = PhantomHDWallet;
//# sourceMappingURL=phantom.js.map